import React from 'react';
import SiteTags from './SiteTags';

export default {
  title: 'Components/Site/SiteDetailsPage/SiteTags',
  component: SiteTags,
  argTypes: {
    handleOpenDeleteModal: { action: 'open delete modal' },
    assignedTags: { control: 'array' },
    setShowTagModal: { action: 'show tag modal' },
  },
  tags: ['autodocs'],
};

const Template = (args) => <SiteTags {...args} />;

export const Default = Template.bind({});
Default.args = {
  assignedTags: [
    { id: 1, name: 'React' },
    { id: 2, name: 'Storybook' },
  ],
};

export const NoTags = Template.bind({});
NoTags.args = {
  assignedTags: [],
};
